import { Method } from 'axios';
import { AxiosQueryArgs } from 'services/api/axiosBaseQuery';

export default class RequestBuilder {
  private readonly base: string;
  private queryParams: URLSearchParams;
  private headers: Record<string, string>;
  private method: Method;
  private data?: object;

  constructor(base: string) {
    this.base = base;
    this.queryParams = new URLSearchParams();
    this.headers = {};
    this.method = 'GET';
  }

  setQueryParam(key: string, value?: string) {
    if (value !== undefined && value !== '') {
      this.queryParams.set(key, value);
    }
    return this;
  }

  appendQueryParam(key: string, value: string) {
    if (value !== undefined && value !== '') {
      this.queryParams.append(key, value);
    }
    return this;
  }

  appendQueryParams(key: string, values?: string[] | string) {
    if (Array.isArray(values)) {
      values.forEach(value => this.queryParams.append(key, value));
    } else if (values) {
      return this.appendQueryParam(key, values);
    }
    return this;
  }

  setMethod(method: Method) {
    this.method = method;
    return this;
  }

  setHeader(key: string, value: string) {
    this.headers = { ...this.headers, [key]: value };
    return this;
  }

  setData(data: object) {
    this.data = data;
    return this;
  }

  buildArgs(): AxiosQueryArgs {
    return {
      url: this.base,
      method: this.method,
      headers: this.headers,
      params: this.queryParams,
      ...(!!this.data && { data: this.data }),
    };
  }
}
